// extracted by mini-css-extract-plugin
export default {"container":"styles_container__s9kpG","content":"styles_content__RY8rq","h4":"styles_h4__D9f8p","carousel":"styles_carousel__ekJNu","grid":"styles_grid__QujnR"};